import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=d63ba562&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=ts&"
export * from "./Splash.vue?vue&type=script&lang=ts&"
import style0 from "./Splash.vue?vue&type=style&index=0&id=d63ba562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63ba562",
  null
  
)

export default component.exports